if (typeof globalThis === 'undefined') {
  // @ts-ignore
  window.globalThis = window
}

export {}
